module.exports = __webpack_public_path__ + "static/img/disposal-2.8f1046e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/disposal-2.png
// module id = Xq7W
// module chunks = 41